/// <amd-module name="TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotSelectors" />
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { IMembersPivotAwareState, ISearchResultCache } from "TFS/Admin/Groups/Common/Contracts";
import { AadGraphMember } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export function getMembers(state: IMembersPivotAwareState): AadGraphMember[] {
    if (!state || !state.membersState || !state.membersState.data) {
        return [];
    }

    if (state.membersState.data.totalIdentityCount > 0) {
        return state.membersState.data.identities;
    }

    return [];
}

export function fetchMoreDataOnLastRow(state: IMembersPivotAwareState): boolean {
    if (!state || !state.membersState || !state.membersState.data) {
        return true;
    }

    return state.membersState.data.moreData;
}

export function getTotalIdentityCount(state: IMembersPivotAwareState): number {
    if (!state || !state.membersState || !state.membersState.data) {
        return 0;
    }

    return state.membersState.data.totalIdentityCount;
}

export function getContinuationToken(state: IMembersPivotAwareState): string[] | undefined {
    if (!state || !state.membersState || !state.membersState.data) {
        return undefined;
    }

    return state.membersState.data.continuationToken;
}

export function showLoadingPanel(state: IMembersPivotAwareState): boolean {
    if (!state || !state.membersState) {
        return true;
    }
    return state.membersState.loading;
}

export function getSearchResult(state: IMembersPivotAwareState): ISearchResultCache {
    if (!state || !state.membersState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.membersState.searchResult;
}

export function getInitComplete(state: IMembersPivotAwareState): boolean {
    if (!state || !state.membersState) {
        return false;
    }
    return state.membersState.initComplete;
}

export function getMessageCardText(state: IMembersPivotAwareState): string | undefined {
    if (!state || !state.membersState) {
        return undefined;
    }

    return state.membersState.messageCardText;
}

export function getMessageCardSeverity(state: IMembersPivotAwareState): MessageCardSeverity | undefined {
    if (!state || !state.membersState) {
        return undefined;
    }

    return state.membersState.messageCardSeverity;
}
